
import React, { useState, useEffect } from "react";

import { Link, useNavigate } from "react-router-dom";

import EventCategoryServices from "../../services/EventCategoryServices";
import EventServices from "../../services/EventServices";

function AddEventCategory() {
    const navigate = useNavigate();
    const [formValues, setFormValues] = useState({
        eventId: "",
        ticketName: "",
        price: "",
        general_ticket_discount:"",
        ticket_discount:"",
        description: "",
        image: null,
        status: "Active",
    });
    const [loading, setLoading] = useState(false);
    const [event, setEvent] = useState([])
    const [imagePreview, setImagePreview] = useState(null);
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormValues((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    const handleImageChange = (e) => {
        const file = e.target.files[0];

        if (!file) return;

        setFormValues((prev) => ({
            ...prev,
            image: file,
        }));

        setImagePreview(URL.createObjectURL(file));
    };

    useEffect(() => {
        const fetchActiveEvents = async () => {
            try {
                const res = await EventServices.getActiveEvents();

                console.log("Active Events:", res);

                if (res?.status) {
                    setEvent(res?.data || []);
                }
            } catch (error) {
                console.error("Get Active Events Error:", error);
            }
        };

        fetchActiveEvents();
    }, []);
    const validateForm = () => {
        if (!formValues.eventId) {
            alert("Event Select required");
            return false;
        }
        if (!formValues.ticketName.trim()) {
            alert("Ticket name required");
            return false;
        }

        if (!formValues.description.trim()) {
            alert("Ticket description required");
            return false;
        }

        if (!formValues.status) {
            alert("Status required");
            return false;
        }

        return true;
    };

    // =====================================================
    // SUBMIT
    // =====================================================

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!validateForm()) return;

        setLoading(true);

        try {
            const formData = new FormData();
            formData.append(
                "eventId",
                formValues.eventId
            );
            formData.append(
                "ticketName",
                formValues.ticketName
            );
            formData.append(
                "ticket_discount",
                formValues.ticket_discount
            );
            formData.append(
                "general_ticket_discount",
                formValues.general_ticket_discount
            );
            formData.append(
                "price",
                formValues.price
            );

            formData.append(
                "description",
                formValues.description
            );

            formData.append(
                "status",
                formValues.status
            );

            // Image optional
            if (formValues.image) {
                formData.append(
                    "image",
                    formValues.image
                );
            }
            for (const [key, value] of formData.entries()) {
                console.log(key, value);
            }
            const res = await EventCategoryServices.createEventCategory(
                formData
            );

            if (res?.status) {
                alert(
                    res?.message ||
                    "Ticket created successfully"
                );

                navigate("/event-ticket-list");
            } else {
                alert(
                    res?.message ||
                    "Failed to create Ticket"
                );
            }
        } catch (error) {
            console.error(
                "Create Ticket Error:",
                error
            );

            alert(
                error?.response?.data?.message ||
                "Failed to create Ticket"
            );
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        return () => {
            if (imagePreview) {
                URL.revokeObjectURL(imagePreview);
            }
        };
    }, [imagePreview]);
    return (
        <>
            <div className="right_col" role="main">
                <div className="d-md-flex align-items-center justify-content-between my-4 page-header-breadcrumb">
                    <div className="my-auto">
                        <h5 className="page-title fs-21 mb-1">
                            Add New Event Ticket
                        </h5>
                        <nav>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <a href="javascript:void(0);">
                                        Home
                                    </a>
                                </li>
                            </ol>
                        </nav>

                    </div>
                    <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
                        <Link
                            className="list-banner-btn"
                            to="/event-ticket-list"
                        >
                            Ticket List
                        </Link>

                    </div>
                </div>
                <div className="container-box">
                    <div className="container-box-inner table-reponsive-tabe">
                        <div className="page-details">
                            <form onSubmit={handleSubmit}>
                              <div className="row">

    {/* Select Event */}
    <div className="col-lg-6 col-sm-12">
        <div className="input-field">
            <label>
                Select Event <span className="red">*</span>
            </label>

            <select
                name="eventId"
                value={formValues.eventId}
                onChange={handleInputChange}
                className="form-control"
            >
                <option value="">Select Event</option>

                {event.map((item) => (
                    <option key={item._id} value={item._id}>
                        {item.eventName}
                    </option>
                ))}
            </select>
        </div>
    </div>

    {/* Ticket Name */}
    <div className="col-lg-6 col-sm-12">
        <div className="input-field">
            <label>
                Ticket Name <span className="red">*</span>
            </label>

            <input
                type="text"
                name="ticketName"
                className="form-control"
                value={formValues.ticketName}
                onChange={handleInputChange}
                placeholder="Enter Ticket name"
            />
        </div>
    </div>
    <div className="col-lg-6 col-sm-12">
        <div className="input-field">
            <label>
                Ticket Price <span className="red">*</span>
            </label>
            <input
                type="number"
                name="price"
                className="form-control"
                value={formValues.price}
                onChange={handleInputChange}
                placeholder="Enter price"
            />
        </div>
    </div>
  <div className="col-lg-6 col-sm-12">
        <div className="input-field">
            <label>
                 GeneralTicket Discount <span className="red">*</span>
            </label>
            <input
                type="number"
                name="general_ticket_discount"
                className="form-control"
                value={formValues.general_ticket_discount}
                onChange={handleInputChange}
                placeholder="Enter price"
            />
        </div>
    </div>
       <div className="col-lg-6 col-sm-12">
        <div className="input-field">
            <label>
                Ticket Discount <span className="red">*</span>
            </label>
            <input
                type="number"
                name="ticket_discount"
                className="form-control"
                value={formValues.ticket_discount}
                onChange={handleInputChange}
                placeholder="Enter price"
            />
        </div>
    </div>
    {/* Status */}
    <div className="col-lg-6 col-sm-12">
        <div className="input-field">
            <label>
                Status <span className="red">*</span>
            </label>

            <select
                name="status"
                className="form-control"
                value={formValues.status}
                onChange={handleInputChange}
            >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
            </select>
        </div>
    </div>

    <div className="col-lg-12 col-sm-12">
        <div className="input-field">
            <label>
                Ticket Benefit <span className="red">*</span>
            </label>

            <textarea
                className="form-control video-desc"
                name="description"
                value={formValues.description}
                onChange={handleInputChange}
                placeholder="Enter Ticket Benefit"
            />
        </div>
    </div>
     

</div>

                                {/* =========================
                                    SUBMIT
                                ========================== */}

                                <div className="text-center mt-4">

                                    <button
                                        className="submit-green-btn"
                                        type="submit"
                                        disabled={loading}
                                        style={{
                                            minWidth: "150px",
                                        }}
                                    >
                                        {loading
                                            ? "SUBMITTING..."
                                            : "SUBMIT"}
                                    </button>

                                </div>

                            </form>

                        </div>

                    </div>

                </div>

            </div>
        </>
    );
}

export default AddEventCategory;

